import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IonIcon } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline, timeOutline } from 'ionicons/icons';
import moment from 'moment';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import Modal from '../../components/modal';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { forwardTo } from '../../lib/utils';
import { QRCodeCanvas } from 'qrcode.react';
import { getConfig } from '../../appConfig';

export const VoucherItem = connect((state) => ({ vouchers: state.profile.vouchers || [] }))(
  ({ never_expires, expiry_date, reward, id, className, action, __, onlyImage, hideCounter, voucher_type, vouchers }) => {
    const matching = vouchers.filter((v) => v.reward?.id === reward.id && v.voucher_type === voucher_type && !v.is_redeemed);
    const available = matching.length;
    const { is_multi_use } = reward
    return (
      <div onClick={action ? () => action(id) : null} className='voucher-wrapper'>
        <div className='voucher-overlay'>
          <img className={'voucher-image' + (className ? ' ' + className : '')} src={reward.image} />
        </div>
        {!onlyImage && (
          <div className="voucher-description">
            <StrongText className='text-to-update'>{__(reward.name)}</StrongText>
            <div>
              {!hideCounter ? (is_multi_use
                ? <SmallText className='bold voucher-counter'>{__('Multi-use')}</SmallText>
                : available === 1
                  ? <SmallText className='bold voucher-counter'>{__('Single-use')}</SmallText>
                  : available > 0 &&
                  <SmallText className='bold voucher-counter'>{`x${available} ${__('available')}`}</SmallText>
              ) :
                <>
                  {is_multi_use ?
                    <SmallText className='bold voucher-counter'>{__('Multi-use')}</SmallText>
                    :
                    <SmallText className='bold voucher-counter'>{__('Single-use')}</SmallText>
                  }
                </>

              }
              <SmallText className='voucher-expiry'>
                {never_expires
                  ? __('No expiry')
                  : <>
                    <IonIcon icon={timeOutline} />
                    {`${__('Expires')} ${moment(expiry_date, 'YYYY/MM/DD').format('LL')}`}
                  </>}
              </SmallText>
            </div>
          </div>
        )}
      </div>
    );
  }
);

class VoucherDetailsClass extends Component {
  state = { activeIndex: null };

  getGroup = () => {
    const { voucher, vouchers } = this.props;
    const group = (vouchers || [])
      .filter((v) => v.reward?.id === voucher.reward?.id && v.voucher_type === voucher.voucher_type && !v.is_redeemed)
      .sort((a, b) => moment(a.expiry_date) - moment(b.expiry_date));
    return group.length > 0 ? group : [voucher];
  };

  moveTo = (index, total) => {
    if (index < 0 || index > total - 1) {
      return;
    }
    this.setState({ activeIndex: index });
  };

  renderSwitcherArrow = (icon, targetIndex, total, disabled) => (
    <div
      className={`voucher-switcher-arrow pointer${disabled ? ' disabled' : ''}`}
      onClick={() => this.moveTo(targetIndex, total)}
    >
      <IonIcon icon={icon} />
    </div>
  );

  renderSwitcher = (group, activeIndex) => {
    const { __ } = this.props;
    const total = group.length;

    return (
      <div className="box-wrapper voucher-switcher">
        {this.renderSwitcherArrow(chevronBackOutline, activeIndex - 1, total, activeIndex === 0)}
        <div className="voucher-switcher-position">
          <StrongText className="block">
            {__('Voucher {index} of {total}', { index: activeIndex + 1, total })}
          </StrongText>
          {total <= 10 &&
            <div className="voucher-switcher-dots">
              {group.map((item, i) => (
                <div
                  className={`voucher-switcher-dot${i === activeIndex ? ' active' : ''}`}
                  key={item.id || `dot-${i}`}
                />
              ))}
            </div>
          }
        </div>
        {this.renderSwitcherArrow(
          chevronForwardOutline,
          activeIndex + 1,
          total,
          activeIndex === total - 1,
        )}
      </div>
    );
  };

  render() {
    const { __, qr_code } = this.props;
    const group = this.getGroup();
    const selectedIndex = this.state.activeIndex ?? Math.max(group.findIndex((v) => v.id === this.props.voucher.id), 0);
    const activeIndex = Math.min(selectedIndex, Math.max(group.length - 1, 0));
    const voucher = group[activeIndex];
    const voucherQRCode = voucher?.additional_config?.qr_code ?? qr_code ?? null;
    return (
      <>
        {group.length > 1 && (
          <>
            {this.renderSwitcher(group, activeIndex)}
            <Spacer size={2} />
          </>
        )}
        <VoucherItem {...voucher} __={__} hideCounter />
        {voucherQRCode && (
          <>
                  <Spacer size={5} />

          <div className='voucher-code-wrapper box-wrapper'>
            <StrongText className='text-to-update'>{__('Show this code in store to redeem')}</StrongText>
            <div className={`qr-holder`}>
              <QRCodeCanvas value={voucherQRCode} size={160} />
            </div>
            {getConfig().flags.showVoucherID && <NormalText style={{ 'word-break': 'break-word', textAlign: 'center' }} className='block'>{voucherQRCode}</NormalText>}
          </div>
          </>
        )}
        <Spacer size={5} />
        <div className="voucher-modal-content">
          <StrongText className="block text-to-update">{__('Voucher info')}</StrongText>
          <Spacer size={1} />
          <div></div>
          <div className='voucher-description-modal'>
            {voucher.reward.description ? <div dangerouslySetInnerHTML={{ __html: voucher.reward.description }} /> : null}
          </div>
          {voucher?.additional_config?.description_lines?.map((line, index) => (
            <React.Fragment key={`description_line_${index}`}>
              <Spacer size={3} />
              <StrongText className='block'>{line.header}</StrongText>
              <Spacer size={1} />
              <NormalText>{line.body}</NormalText>
            </React.Fragment>
          ))}
        </div>
      </>
    );
  }
}

const VoucherDetails = connect((state) => ({
  qr_code: state.profile.profile?.qr_code,
  vouchers: state.profile.vouchers || [],
}))(VoucherDetailsClass);

export const VoucherModal = withTranslation(({ __, voucher, onDismiss }) => (
  <Modal
    className="voucher-modal"
    isOpen={!!voucher}
    onDidDismiss={onDismiss}
  >
    {voucher && voucher.reward ? (
      <div>
        <Title className='modal-title'>{__('Voucher details')}</Title>
        <Spacer size={2} />
        <VoucherDetails key={voucher.id} voucher={voucher} __={__} />
      </div>
    ) : null}
  </Modal>
));

class Voucher extends Component {
  componentDidMount() {
    if (!this.props.location?.state?.voucher) {
      forwardTo('/loyalty')
    }
  }
  render() {
    const { __ } = this.props;
    const voucher = this.props.location?.state?.voucher
    return (
      <Loading>
        <Layout color="transparent" >
          <div className='absolute-content scrollable-y'>
            <Title className='page-title-centered'>{__('Voucher details')}</Title>
            {voucher?.reward && <VoucherDetails key={voucher.id} voucher={voucher} __={__} />}
          </div>
        </Layout>
      </Loading>
    );
  }
}

export default withTranslation(Voucher);
